export const isNotEmptyArray = (arr: any): boolean =>
  arr != null && Array.isArray(arr) && arr.length > 0;
